import * as React from 'react';
import styled from 'styled-components';
import SelectRich from '../components/SelectRich';
import {
  Resolution,
  STANDARDS,
  isStandardResolution
} from '../data/Resolution';
import PixelRatio from '../data/PixelRatio';
import ResolutionOption from './components/ResolutionOption';
import { storeDispatch, isUserPro, getStoreState } from '../state/Store';
import * as Actions from '../state/actions';
import { generateClassName } from 'utils';
import { EditResolutionCommand } from 'state/commands/EditResolutionCommand';

const Wrapper = styled.div`
  > * {
    margin: 0 5px;
  }
`;

interface Props {
  resolution: Resolution;
  previewPixelRatio: PixelRatio;
  collapsed: boolean;
}

export default class extends React.Component<Props> {
  state = {
    isAddingResolution: true
  };

  promptAddResolution = () => {
    if (!isUserPro()) {
      storeDispatch(Actions.showBuyingOptions());
    } else {
      storeDispatch(Actions.promptAddResolution());
    }
  };

  didSelectResolution = (resolution: Resolution) => {
    if (!isUserPro() && !isStandardResolution(resolution)) {
      storeDispatch(Actions.showBuyingOptions());
    } else {
      storeDispatch(new EditResolutionCommand(resolution));
    }
  };

  didChangePreviewPixelRatio = (ratio: PixelRatio) => {
    storeDispatch(Actions.changePreviewPixelRatio(ratio));
  };

  render() {
    let sizeOptions = STANDARDS.concat();
    if (isUserPro()) {
      sizeOptions = sizeOptions.concat(
        getStoreState().app.user!.customResolutions
      );
    }
    const hasCanvasConfirmation = getStoreState().app.editedShape !== null;
    const { collapsed } = this.props;
    return (
      <Wrapper className={generateClassName('options-bar', { collapsed })}>
        {hasCanvasConfirmation ? (
          <>Move the shape corners or add new ones by dragging the borders.</>
        ) : (
          <SelectRich
            legend="Size"
            options={sizeOptions}
            value={this.props.resolution}
            formatter={(value: any) => {
              const resolution = value as Resolution;
              return resolution.width + ' x ' + resolution.height;
            }}
            itemRenderer={ResolutionOption}
            onSelect={this.didSelectResolution}
            addLabel="New custom size..."
            onAdd={this.promptAddResolution}
          />
        )}

        {/*canRecordVideoAsync() && (
          <SelectRich
            legend="Preview quality"
            options={PIXEL_RATIO_ALL}
            value={this.props.previewPixelRatio}
            formatter={(value: any) => {
              const ratio: PixelRatio = value as PixelRatio;
              if (ratio.name === 'Medium') {
                return 'Mid';
              }
              return ratio.name;
            }}
            itemRenderer={SelectOption}
            onSelect={this.didChangePreviewPixelRatio}
          />
          )*/}
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/showcase/OptionsBar.tsx